import script from "./DocumentTableLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentTableLayout.vue?vue&type=script&setup=true&lang=js"

import "./DocumentTableLayout.vue?vue&type=style&index=0&id=3b034bb4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b034bb4"]])

export default __exports__